import type { FinancialStatement } from "@/types/financial"
import client from "./client"

export async function getFinancialYears(code: string): Promise<string[]> {
  const { data } = await client.get<string[]>(`/api/financials/${code}/years`)
  return data
}

export async function getFinancials(
  code: string,
  bsnsYear: string,
  reprtCode: string,
  sjDiv?: string,
  fsDiv?: string,
): Promise<FinancialStatement[]> {
  const { data } = await client.get<FinancialStatement[]>(`/api/financials/${code}`, {
    params: { bsns_year: bsnsYear, reprt_code: reprtCode, sj_div: sjDiv, fs_div: fsDiv },
  })
  return data
}
